import { DecodedToken } from '@readcloud/casl';
import { createContext } from 'react';

export const tokenContext = createContext<DecodedToken>(null);
